export default "__VITE_ASSET__219f3991__"